import { OnboardingWorkflow } from '../../../CommonSelectors/CommonArea.types';
import { WorkflowIdEnum } from '../../api/useWorkflowDataQuery';

export const WORKFLOW_ID_MAP = {
  [OnboardingWorkflow.Comprehensive]: WorkflowIdEnum.Comprehensive,
  [OnboardingWorkflow.AssetBucketingWorkflow]: WorkflowIdEnum.AssetBucketing,
  [OnboardingWorkflow.EstatePlanning]: WorkflowIdEnum.EstatePlanning,
};
